import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold"
      [ngClass]="badgeClass"
    >
      {{ value }}
    </span>
  `
})
export class StatusBadgeComponent {
  @Input({ required: true }) value!: string;

  get badgeClass(): string {
    const normalized = this.value.toUpperCase();

    if (
      ['ON_TRACK', 'READY', 'FINALIZED', 'CONFIRMED', 'RESOLVED', 'DONE', 'ACTIVE', 'VALIDATED', 'PASS', 'CONNECTED',
        'COMPLETED', 'IMPORTED', 'DUPLICATE', 'MAPPED', 'APPROVED', 'EXECUTED']
        .includes(normalized)
    ) {
      return 'bg-emerald-100 text-emerald-700';
    }

    if (
      [
        'AT_RISK',
        'PENDING',
        'OPEN',
        'OPENED',
        'WAITING',
        'IN_PROGRESS',
        'NEEDS REVIEW',
        'ONBOARDING',
        'READY_FOR_VALIDATION',
        'WARN'
      ].includes(normalized)
    ) {
      return 'bg-amber-100 text-amber-700';
    }

    if (
      ['ACTION_REQUIRED', 'CRITICAL', 'DISMISSED', 'DECLINED', 'REJECTED', 'DISABLED', 'FAIL', 'NEEDS_ATTENTION', 'ERROR',
        'FAILED', 'CANCELED', 'DEADLETTERED'].includes(
        normalized
      )
    ) {
      return 'bg-rose-100 text-rose-700';
    }

    if (['SNOOZED', 'EXPIRED'].includes(normalized)) {
      return 'bg-sky-100 text-sky-700';
    }

    return 'bg-slate-100 text-slate-700';
  }
}
